<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" icon="fas fa-pen-nib" title="Sửa thông tin tài liệu" />
    <el-form ref="formPlagiarism" label-width="160px" label-position="right" @submit.native.prevent>
      <el-form-item label="Tiêu đề">
        <el-input placeholder="Tiêu đề tài liệu" v-model="document.title"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Hủy bỏ</el-button>
      <CommonButton type="primary" @click="onSubmitEditDocumentForm"> Cập nhập tài liệu </CommonButton>
    </span>
  </el-dialog>
</template>

<script>
import { apiUpdateGroupDocument } from '@/services/document_management_service'
import FAIcon from '@/components/common/FAIcon.vue'
import _ from 'lodash'
import ModalHeader from '@/components/common/ModalHeader.vue'
import CommonButton from '@/components/common/CommonButton.vue'
export default {
  name: 'GroupDocumentEditModal',
  components: { CommonButton, ModalHeader, FAIcon },
  data: function () {
    return {
      show: false,
      document: null,
    }
  },
  methods: {
    openModal(document) {
      this.document = _.cloneDeep(document)
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    async onSubmitEditDocumentForm() {
      apiUpdateGroupDocument(this.document.slug, this.document.title)
        .then(() => {
          this.$message.success('Chỉnh sửa thành công')
          this.show = false
          this.$emit('success')
        })
        .catch(() => {
          this.$message.error('Có lỗi xảy ra')
        })
    },
  },
}
</script>
